import {RouterProps} from "../../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {
    ContentUserProductionDurationVerboseValueObject
} from "../../../../data/value-object/content/ContentUserProductionDurationVerboseValueObject";
import {useCallback, useEffect} from "react";
import {ContentUserProductionDurationIO} from "../../../../io/ContentIO";
import {Button, Title3} from "@fluentui/react-components";
import {PostFieldWrapper, PostNumberField} from "../../../PostField";
import {
    ContentUserProductionDurationDescription
} from "../../../../data/description/content/ContentUserProductionDurationDescription";

enum Phase {
    Loading,
    Waiting,
    Putting,
    Finished,
}

export default function Edit(props: RouterProps) {
    const params = useParams<{ contentUserProductionDurationId: string }>()
    const item = useStatePair<ContentUserProductionDurationVerboseValueObject | undefined>(undefined)
    const phase = useStatePair<Phase>(Phase.Loading)
    const value = useStatePair(0)
    const displayOrder = useStatePair(0)

    useEffect(() => {
        if (item.value === undefined && params.contentUserProductionDurationId !== undefined) {
            ContentUserProductionDurationIO
                .getVerboseById(BigInt(params.contentUserProductionDurationId))
                .then(_value => {
                    item.setter(_value)
                    value.setter(_value.value)
                    displayOrder.setter(_value.displayOrder)
                    phase.setter(Phase.Waiting)
                })
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    const onDoneClick = useCallback(() => {
        const id = item.value?.id
        if (id === undefined) {
            return
        }

        phase.setter(Phase.Putting)
        ContentUserProductionDurationIO
            .put(id, {
                value: value.value,
                displayOrder: displayOrder.value
            })
            .then(() => {
                phase.setter(Phase.Finished)
                alert('수정되었습니다.')
                document.location = `/contents/userProduction/durations/${id}`
            })
            .catch(reason => {
                console.error(reason)
                alert('수정을 실패했습니다.')
                phase.setter(Phase.Waiting)
            })
    }, [value.value, displayOrder.value])

    return <>
        <div className={props.styles.column16}>
            <Title3>수정</Title3>
            <PostFieldWrapper
                {...props}
                title={ContentUserProductionDurationDescription.value}>
                <PostNumberField
                    {...props}
                    value={value.value}
                    setter={value.setter}/>
            </PostFieldWrapper>
            <PostFieldWrapper
                {...props}
                title={ContentUserProductionDurationDescription.displayOrder}>
                <PostNumberField
                    {...props}
                    value={displayOrder.value}
                    setter={displayOrder.setter}/>
            </PostFieldWrapper>
            <div className={props.styles.row}>
                <Button
                    appearance={'primary'}
                    disabled={phase.value !== Phase.Waiting}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </div>
        </div>
    </>
}